import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { apiUtil, useGetPackageQuery } from '../api';
/**
 * Polls package status while not published and invalidates caches when published.
 * This ensures all pages see fresh data when backend processing completes.
 *
 * @param projectId - The project ID
 * @param packageId - The package ID
 * @param isPublished - Current published status
 * @param skip - Skip polling (e.g., when admin features enabled)
 */
export const usePublishedPolling = (projectId, packageId, initialIsPublished, skip = false) => {
    const dispatch = useDispatch();
    const prevPublishedRef = useRef(initialIsPublished);
    const { data: polledPackage } = useGetPackageQuery({ projectId, packageId }, { pollingInterval: initialIsPublished || skip ? 0 : 10000 });
    const isPublished = polledPackage?.published ?? initialIsPublished;
    useEffect(() => {
        if (!prevPublishedRef.current && isPublished) {
            dispatch(apiUtil.invalidateTags([
                'Findings',
                'DashboardData',
                'Blobs',
                'DocumentPackageSummary',
                'DocumentPackages',
            ]));
        }
        prevPublishedRef.current = isPublished;
    }, [isPublished, dispatch]);
    return { isPublished };
};
